export default "__VITE_ASSET__Cd2VqHc8__"